export const menuItems = [
  // {
  //   name: 'generalProgramming',
  //   en: '/en/general-programming',
  //   pt: '/pt/programacao-geral',
  // },
  {
    name: 'exhibitors',
    en: '/en/exhibitors',
    pt: '/pt/expositores',
  },
  {
    name: 'agenda',
    en: '/en/agenda',
    pt: '/pt/agenda',
  },
  {
    name: 'organization',
    en: '/en/organization',
    pt: '/pt/organizacao',
  },
];

export const menuExtraItems = [
  // {
  //   name: 'organization',
  //   en: '/en/organization',
  //   es: '/es/organizacion',
  //   pt: '/pt/organizacao',
  // },
];



/** WEBPACK FOOTER **
 ** ./src/defaults/menuItems.js
 **/